<script setup lang="ts">
import { useSearchHighlightText } from '@/composables/useSearchSearchHighlightText';
import { computed } from 'vue';
import { getSearchHighlightChunks } from './searchTextHighlighter.utils';

const props = withDefaults(
  defineProps<{
    text: string;
    highlightSearchTermsIndependently?: boolean;
  }>(),
  {
    highlightSearchTermsIndependently: true,
  },
);

const highlight = useSearchHighlightText();

const chunks = computed(() =>
  getSearchHighlightChunks({
    matchSearchTermsIndependently: props.highlightSearchTermsIndependently,
    searchQuery: highlight?.value,
    text: props.text,
  }),
);
</script>

<template>
  <template v-if="!highlight">{{ text }}</template>
  <template v-else>
    <template v-for="(chunk, index) of chunks">
      <template v-if="typeof chunk === 'string'">{{ chunk }}</template>
      <mark v-else-if="chunk.text" :key="index" class="rounded outline-tint outline outline-2 bg-tint bg-op-20">
        {{ chunk.text }}
      </mark>
    </template>
  </template>
</template>
